// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_2bZy3","line":"index_line_3dcqm","login":"index_login_3v75c","statement":"index_statement_1FqbZ"};